class GalleryComponent extends HTMLElement {

  constructor () {

    super()
    this.gallery      = this.querySelector('.gallery__container');
    this.galleryItems = this.querySelectorAll('.gallery__image');
    this.galleryContent = this.querySelector('.gallery__content');
    this.galleryCaption = this.querySelector('.gallery__caption');
    this.prevButton   = this.querySelector('.gallery__prev');
    this.nextButton   = this.querySelector('.gallery__next');
    this.pagination   = this.querySelector('.gallery__pagination');

    this.currentPage  = 1;

    this.isDragging       = false;
    this.startPosition    = 0;
    this.startScrollLeft  = 0;


    console.log("GalleryComponent");

    if (!this.gallery) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
          resizeObserver.observe(this.gallery);

    this.gallery.addEventListener('scroll', this.updateNavigation.bind(this));

    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    };
    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    this.initPages()

  }

  initPages () {
    this.galleryItemsToShow = Array.from(this.galleryItems).filter(element => element.clientWidth > 0); 
    if (this.galleryItemsToShow.length <= 1) return;
    this.galleryItemWidth = this.galleryItemsToShow[0].getBoundingClientRect().width;
    this.slidesPerPage = Math.floor(this.gallery.getBoundingClientRect().width / this.galleryItemWidth);
    this.totalPages = this.galleryItemsToShow.length - this.slidesPerPage + 1;
    this.updateNavigation();
  }



  updateNavigation () {

    this.currentPage = Math.round(this.gallery.scrollLeft / this.galleryItemWidth) + 1;

    let currentSlide = this.galleryItems[this.currentPage-1];

    this.galleryContent.innerHTML = currentSlide.querySelectorAll("template")[0].innerHTML;
    this.galleryCaption.innerHTML = currentSlide.querySelectorAll("template")[0].innerHTML;

    this.pagination.innerHTML = this.currentPage + " / " + this.galleryItemsToShow.length;

    if (this.prevButton) {
      this.prevButton.removeAttribute('disabled');
      if (this.currentPage == 1 ||  this.galleryItemsToShow.length < this.slidesPerPage) this.prevButton.setAttribute('disabled', 'disabled');
    }
    if (this.nextButton) {
      this.nextButton.removeAttribute('disabled');
      if (this.currentPage == this.totalPages || this.galleryItemsToShow.length < this.slidesPerPage) this.nextButton.setAttribute('disabled', 'disabled');
    }
    if (this.galleryItemsToShow.length < this.slidesPerPage || this.totalPages == 1) {
      this.prevButton.style.visibility = 'hidden';
      this.nextButton.style.visibility = 'hidden';
    }

    // for (let i = 0; i < this.pagination.children.length; i++) {
    //   this.pagination.children[i].classList.remove('active');
    // }
    // this.pagination.children[this.currentPage-1].classList.add('active');


  }

  setActiveSlide (page) {
    this.slideScrollPosition = page * this.galleryItemWidth;
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  onButtonClick (event) {
    event.preventDefault();
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.gallery.scrollLeft + this.galleryItemWidth : this.gallery.scrollLeft - this.galleryItemWidth;

    this.gallery.scrollTo({
      left: this.slideScrollPosition
    });
  }

  
}

customElements.define('gallery-component', GalleryComponent)